import React, { useState } from 'react'
// import HeaderBack from '../../components/global/HeaderBack'
import iconLogin from './../../assets/auth/illustration-dashboard.webp'
import { Container, Grid, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FormRegister from '../../components/auth/FormRegister';
import FormOtpRegister from '../../components/auth/FormOtpRegister';

const Register = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1); // 1: Data entry, 2: OTP verification
  const [registrationData, setRegistrationData] = useState(null);

  const handleRegisterSuccess = (data) => {
    setRegistrationData(data);
    setStep(2);
  };

  return (
    <>
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: (theme) => theme.palette.mode === 'dark'
            ? 'radial-gradient(circle at top right, #1e293b, #020617)'
            : 'radial-gradient(circle at top right, #f8fafc, #f1f5f9)',
          py: 4
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={{ md: 8, xs: 4 }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: { xs: 'none', md: 'flex' },
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <Typography variant="h2" mb={2} sx={{ fontWeight: 800, color: 'primary.main' }}>
                  {t('auth.registerTitle')}
                </Typography>
                <Typography variant="h5" color="text.secondary" mb={4}>
                  {t('auth.registerSubtitle')}
                </Typography>
                <Box
                  component="img"
                  src={iconLogin}
                  alt="Register"
                  sx={{
                    maxWidth: '90%',
                    height: 'auto',
                    filter: 'drop-shadow(0px 20px 40px rgba(0,0,0,0.1))',
                    animation: 'float 6s ease-in-out infinite',
                    '@keyframes float': {
                      '0%': { transform: 'translateY(0px)' },
                      '50%': { transform: 'translateY(-20px)' },
                      '100%': { transform: 'translateY(0px)' },
                    }
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ width: '100%', maxWidth: 520, mx: 'auto' }}>
                <Box sx={{ display: { xs: 'block', md: 'none' }, textAlign: 'center', mb: 4 }}>
                  <Typography variant="h4" fontWeight={700} gutterBottom>
                    {t('auth.signUp')}
                  </Typography>
                </Box>
                {step === 1 ? (
                  <FormRegister onSuccess={handleRegisterSuccess} />
                ) : (
                  <FormOtpRegister
                    initialData={registrationData}
                    onBack={() => setStep(1)}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  )
}

export default Register
